import { Component } from '@angular/core';
import { Router, RoutesRecognized } from "@angular/router";
import { TokenService } from "./services/auth/token.service";
import { InstallationService } from './services/installation.service';
import { UserPreferencesService } from './services/storage/user_preferences.service';
import { DarkModeService } from './services/interface/dark-mode.service';


export enum AppLayouts {
   Guest,              // Guest layout
   ExternalOutlet,     // External (New browser tab) Outlet layout
   User                // User session layout
}

@Component({
   selector: 'app-root',
   templateUrl: './app.component.html',
   styleUrls: ['./app.component.scss']
})
export class AppComponent {
   title = 'JBM - CIS';

   AppLayouts = AppLayouts
   AppLayout: AppLayouts | null = null;

   constructor(
      private InstallationService: InstallationService,
      private UserPreferencesService: UserPreferencesService,
      private router: Router,
      private TokenService: TokenService,
      private DarkModeService: DarkModeService
   ) {}

   ngOnInit() {
      // We can't use `ActivatedRoute` here since we are not within a `router-outlet` context yet.
      this.router.events.subscribe((data: any) => {
         if (data instanceof RoutesRecognized && data.state.root.firstChild) {
            this.AppLayout = data.state.root.firstChild.data.AppLayout;
         }
      });

      this.DarkModeService.check()

      this.InstallationService.getTokenVersion().subscribe((result: any) => {
         if (this.TokenService.getTokenVersion() !== result.data) {
            // User is forced to login by system administrator  
            localStorage.removeItem('token')
            this.router.navigateByUrl('login');
         } else {
            if(!this.TokenService.getUserId())
               return
            this.loadUserPreferences()      
         }
      })
   }
   loadUserPreferences() {
      this.UserPreferencesService.get().subscribe( (result: any) => {}, (error: any) => console.error(error) )
   }
}
